import api from "./api";

export const listAgents = async () => {
  const { data } = await api.get("/agentIa/agents");
  return data;
};

export const createAgent = async (payload) => {
  const { data } = await api.post("/agentIa/agents", payload);
  return data;
};

export const updateAgent = async (agentId, payload) => {
  const { data } = await api.put(`/agentIa/agents/${agentId}`, payload);
  return data;
};

export const deleteAgent = async (agentId) => {
  const { data } = await api.delete(`/agentIa/agents/${agentId}`);
  return data;
};

export const listDocuments = async (agentId) => {
  const { data } = await api.get(`/agentIa/agents/${agentId}/documents`);
  return data;
};

export const uploadDocument = async (agentId, file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(`/agentIa/agents/${agentId}/documents`, form);
  return data;
};

export const deleteDocument = async (agentId, documentId) => {
  const { data } = await api.delete(
    `/agentIa/agents/${agentId}/documents/${documentId}`
  );
  return data;
};

export const openDocumentFile = async (agentId, documentId) => {
  const { data, headers } = await api.get(
    `/agentIa/agents/${agentId}/documents/${documentId}/file`,
    { responseType: "blob" }
  );
  const blobUrl = window.URL.createObjectURL(
    new Blob([data], { type: headers["content-type"] })
  );
  window.open(blobUrl, "_blank");
};

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const chatWithAgent = async (agentId, question, imageFile, history) => {
  const payload = { question, history: history || [] };
  if (imageFile) {
    payload.image_base64 = await fileToBase64(imageFile);
    payload.image_media_type = imageFile.type;
  }
  const { data } = await api.post(`/agentIa/agents/${agentId}/chat`, payload);
  return data;
};

export const listQna = async (agentId, status) => {
  const { data } = await api.get(`/agentIa/agents/${agentId}/qna`, {
    params: status ? { status } : {},
  });
  return data;
};

export const saveQna = async (agentId, payload) => {
  const { data } = await api.post(`/agentIa/agents/${agentId}/qna`, payload);
  return data;
};

export const updateQna = async (qnaId, payload) => {
  const { data } = await api.put(`/agentIa/qna/${qnaId}`, payload);
  return data;
};

export const deleteQna = async (qnaId) => {
  const { data } = await api.delete(`/agentIa/qna/${qnaId}`);
  return data;
};

export const listTagRoutes = async () => {
  const { data } = await api.get("/agentIa/tagRoutes");
  return data;
};

export const createTagRoute = async (payload) => {
  const { data } = await api.post("/agentIa/tagRoutes", payload);
  return data;
};

export const updateTagRoute = async (routeId, payload) => {
  const { data } = await api.put(`/agentIa/tagRoutes/${routeId}`, payload);
  return data;
};

export const deleteTagRoute = async (routeId) => {
  const { data } = await api.delete(`/agentIa/tagRoutes/${routeId}`);
  return data;
};

export const getPendingDraft = async (ticketId) => {
  const { data } = await api.get(`/agentIa/tickets/${ticketId}/pendingDraft`);
  return data;
};

export const sendDraftReply = async (draftId, finalAnswer) => {
  const { data } = await api.post(`/agentIa/draftReplies/${draftId}/send`, {
    finalAnswer,
  });
  return data;
};

export const discardDraftReply = async (draftId) => {
  const { data } = await api.post(`/agentIa/draftReplies/${draftId}/discard`);
  return data;
};
